"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var MenuCartDisplayBanner = function MenuCartDisplayBanner(_ref) {
  var _ref$cartDisplayTitle = _ref.cartDisplayTitle,
      cartDisplayTitle = _ref$cartDisplayTitle === void 0 ? 'Order Summary' : _ref$cartDisplayTitle,
      onToggleMobileCart = _ref.onToggleMobileCart,
      mobileCartOpen = _ref.mobileCartOpen,
      numberOfItems = _ref.numberOfItems;
  return _react["default"].createElement("div", {
    className: "menu-cart-banner",
    onClick: onToggleMobileCart
  }, _react["default"].createElement("h4", null, cartDisplayTitle), _react["default"].createElement("h4", null, numberOfItems, " Item", numberOfItems !== 1 ? 's' : ''), _react["default"].createElement("div", {
    className: "menu-cart-mobile"
  }, _react["default"].createElement(_semanticUiReact.Icon, {
    className: mobileCartOpen ? 'flip' : '',
    name: "angle up",
    size: "large",
    onClick: onToggleMobileCart
  })));
};

var _default = MenuCartDisplayBanner;
exports["default"] = _default;